import Managed from "@/features/user/components/managed/managed";
import { useLng } from "@/hooks/use-lng";
import { appTitleHead } from "@/lib/app-document-title";
import { useTranslation } from "@/lib/i18n/client";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/account/_auth/registermanaged")({
  head: () => appTitleHead("account-register-managed-title"),
  component: RegisterManagedPage
});

function RegisterManagedPage() {
  const lng = useLng();
  const { t } = useTranslation(lng, "translation");
  return (
    <div className="flex h-full min-h-[calc(100%-9rem)] flex-col">
      <h1 className="hidden text-left md:block">{t("managed-header")}</h1>
      <p>{t("managed-description")}</p>
      <p>{t("managed-description-extra")}</p>
      <Managed />
    </div>
  );
}
